import jpgImage from '../assets/FileIcons/ic-jpg.svg'
import pdfImage from '../assets/FileIcons/ic-pdf.svg'
import pngImage from '../assets/FileIcons/ic-png.svg'
import fileIcon from '../assets/FileIcons/ic-file.svg'
import dcmicon from '../assets/FileIcons/ic-dcm.svg'
import docicon from '../assets/FileIcons/ic-doc.svg'
import zipicon from '../assets/FileIcons/ic-zip.svg'
import Assets from '../components/Layout/Assets'

let FILE_SCHEMA =
{
    "pdf": pdfImage,
    "jpg": jpgImage,
    "jpeg": jpgImage,
    "png": pngImage,
    "file": fileIcon,
    "dcm": dcmicon,
    "doc": docicon,
    "zip": zipicon,
    "docx":docicon,
    "DCM": dcmicon,
    "PDF": pdfImage,
    "JPG": jpgImage,
    "JPEG": jpgImage,
    "PNG": pngImage,
    "File": fileIcon,
    "DOC": docicon,
    "ZIP":zipicon,
    "DOCX":docicon,
    
}



export let getFileTypeFromFileName = (fileName) => {


    if (fileName) {
        var fileExt = fileName.split('.').pop();

        if (fileExt) {
            let fileIcon = FILE_SCHEMA[fileExt.toLowerCase()]

            if (fileIcon) {

                return fileIcon
            }
            else {

                return FILE_SCHEMA.file
            }

        }
        else {

            return FILE_SCHEMA['file']
        }

    }
    else {
        return FILE_SCHEMA['file']
    }




}


export const generateUniqueFileName = ()=>{
    return 'file'+(new Date()).getTime();
}

